import { selectIsAuthorized } from '@beef/shop-common';

import { TabEnum } from 'store/ProductDetails/constants';

import { positionGTMEnum } from './constants';

export const getCurrentUrl = () => {
  if (typeof window === 'undefined' || !window.location) return '';
  const { protocol, host, pathname } = window.location;
  return `${protocol}//${host}${pathname}`;
};

export const commonClickEvent = {
  event: 'ShopEvent',
  eventCategory: 'commonClick',
  eventLabel: getCurrentUrl(),
};

export const remainsNumToText = (remainsNum) => {
  switch (remainsNum) {
    case 1: {
      return 'Нет';
    }
    case 2: {
      return 'Временно нет';
    }
    case 3: {
      return 'Мало';
    }
    case 4: {
      return 'Средне';
    }
    case 5: {
      return 'Много';
    }
    default:
      return null;
  }
};

export const sectionToGTMPosition = (section) => {
  switch (section) {
    case TabEnum.CONTENT_TAB_CROSS_SALE: {
      return positionGTMEnum.CONTENT_TAB_CROSS_SALE;
    }
    default:
      return null;
  }
};

export const getCommonFields = () => ({
  page_url: `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
  page_path: window.location.pathname,
  page_title: document.title,
  account_type: selectIsAuthorized() ? 'authorized' : 'none',
});
